import { css } from 'styled-system/css';

export const bookingButtonStyle = {
	bookedButton: css({
		_mars: {
			bgColor: 'booked.2_50',
			color: 'booked.4',
			md: {
				_hover: {
					bgColor: 'booked.2',
					color: 'whiteOpacity.100',
				},
			},
			'&[data-disabled="true"]': {
				bgColor: 'var(--s800)',
				color: 'black.3',
				_hover: {
					bgColor: 'var(--s800)',
					color: 'black.3',
				}
			},
			_active: {
				bgColor: 'booked.3',
				color: 'whiteOpacity.100',
			},
		},
	}),
};
